
import { mapGetters } from "vuex";
import rippleIndicator from "../common/ripple-indicator.vue";
import OrderActionButton from "./order-action-btn.vue";
import TextBubbleAlert from "../common/text-bubble-alert.vue";
import OrderDurationProgress from "./order-duration-progress.vue";
import OrderOtpChipMobile from "./order-otp-chip-mobile.vue";
import ManualOrderCompletionDialog from "../dialogs/manual-order-completion-dialog.vue";
import BrandAvatarWithColor from "../common/brand-avatar-with-color.vue";
import CurrencyConverter from "../common/currency-converter.vue";
export default {
  components: {
    rippleIndicator,
    OrderActionButton,
    TextBubbleAlert,
    OrderDurationProgress,
    OrderOtpChipMobile,
    ManualOrderCompletionDialog,
    BrandAvatarWithColor,
    CurrencyConverter
  },
  data() {
    return {
      // secondsSinceCreated: 0,
      // secondsSincePreparing: 0,
      minutesSinceDispatched: 0,
      showManualOrderCompletionDialog: false,
      timer: null
    };
  },
  mounted() {
    if (this.status === "pickedUp") {
      this.minutesSinceDispatched = this.getTimeDifferenceInMinute(
        this.order.dispatched_at
      );
      this.timer = setInterval(() => {
        this.minutesSinceDispatched++;
      }, 60000);
    }
  },
  props: {
    headers: {},
    selectedHeader: {},
    order: {},
    status: "",
    isOrderAutoAcceptEnabled: false
  },
  methods: {
    getOrderId() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        const unmaskedId = String(
          this.order.merchant_ref_id || this.order.partner_order_id
        );
        const length = unmaskedId.length;
        if (!unmaskedId) {
          return "";
        }
        if (length < 4) {
          return unmaskedId;
        }

        if (this.$vuetify.breakpoint.lgAndUp) {
          return unmaskedId;
        }

        const mask = `<span class='font-weight-light'>${"x".repeat(
          length - 4
        )}</span>`;
        const lastFourDigits = `<span>${unmaskedId.slice(length - 4)}</span>`;
        return `${mask}${lastFourDigits}`;
      } else {
        if (this.order.merchant_ref_id) {
          return String(this.order.merchant_ref_id).substr(
            String(this.order.merchant_ref_id).length - 4,
            4
          );
        }
        if (this.order.partner_order_id) {
          return String(this.order.partner_order_id).substr(
            String(this.order.partner_order_id).length - 4,
            4
          );
        }
        return "";
      }
    },
    handleOrderGridClick() {
      if (this.status === "pickedUp" && this.isDispatchTimedOut) {
        this.showManualOrderCompletionDialog = true;
      } else {
        this.$router.push("/reciever/" + this.order.id);
      }
    }
  },
  computed: {
    ...mapGetters("restaurant", ["hasMultipleBrands", "getRestaurantName"]),
    isDispatchTimedOut() {
      const timeoutInHours = 4;
      return this.minutesSinceDispatched > timeoutInHours * 60;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
